import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import {
  CheckShiftActivityPermissionsService,
  DropZoneEventThrottlerDirective,
  GanttDateToPositionPxPipe,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import { DragAndDropModeService } from '@wilson/shift-timeline/services';
import { firstValueFrom } from 'rxjs';
import { TimelineShiftAssignService } from '../../services/timeline-shift-assign.service';
import { GroupAssignmentHelperService } from '../group-assignment-confirmation-modal/group-assignment-helper.service';
import { AssignShiftDropZoneHelperService } from './new-shift-drop-zone-helper.service';

@Component({
  selector: 'wilson-assign-shift-drop-zone-v2',
  imports: [],
  template: '',
  styleUrls: ['./assign-shift-drop-zone-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    GanttDateToPositionPxPipe,
    TimelineShiftAssignService,
    GroupAssignmentHelperService,
    AssignShiftDropZoneHelperService,
  ],
})
export class AssignShiftDropZoneV2Component extends DropZoneEventThrottlerDirective {
  private readonly assignShiftDropZoneHelperService = inject(
    AssignShiftDropZoneHelperService,
  );
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  private readonly checkShiftActivityPermissionsService = inject(
    CheckShiftActivityPermissionsService,
  );

  @Input() userId!: string | undefined;

  protected override async onDragOverHandler(): Promise<void> {
    await this.assignShiftDropZoneHelperService.onDragOverHandler(this.userId);
  }

  protected override async onDragLeaveHandler(): Promise<void> {
    await this.assignShiftDropZoneHelperService.onDragLeaveHandler(this.userId);
  }

  protected override async onDropHandler(): Promise<void> {
    const draggingShift = await firstValueFrom(
      this.dragAndDropModeService.draggingShiftV2$,
    );

    await this.checkShiftActivityPermissionsService.checkShiftActivityPermissions(
      {
        shiftIds: [draggingShift?.id as string],
        onSuccess: async () => {
          await this.assignShiftDropZoneHelperService.onDropStandardViewHandler(
            this.userId,
            draggingShift,
          );
        },
        onFailure: () => {
          this.assignShiftDropZoneHelperService.removeDraggingShift(
            this.userId as string,
          );
          this.dragAndDropModeService.setDraggingShiftV2(null);
        },
      },
    );
  }
}
